export const groupingRules: Record<string, { editEntities: string[] }> = {
  section1_manufacturer: {
    editEntities: ['section1_manufacturer'],
  },
  section1_importer: {
    editEntities: ['section1_importer'],
  },
  section2: {
    editEntities: ['section2'],
  },
  section3_material: {
    editEntities: ['section3_material', 'section3_cas'],
  },
  section3_impurity_material: {
    editEntities: ['section3_impurity_material', 'section3_impurity_cas'],
  },
  // ACGIH/JSOH/DNEL_DMEL are no longer separate tables/entities -- the
  // organization is now just a column (organization_id) on one unified
  // section8_exposure_control(_material) pair, and cas is embedded in the
  // material row rather than a separate child entity. Paired like
  // section3_material/section3_cas: adding an org entry together with its
  // material(s) collapses into one line.
  section8_exposure_control: {
    editEntities: [
      'section8_exposure_control',
      'section8_exposure_control_material',
    ],
  },
  section8_exposure_control_material: {
    editEntities: ['section8_exposure_control_material'],
  },
  // The law row, its material(s) and their CAS numbers are always entered
  // as one set (no UI path adds a material/CAS without also touching the
  // law row), so when the law row itself is part of a save, it also
  // collapses its material(s)/CAS into the same line -- see the
  // editEntity === 'section15' carve-out in SdsTableEditHistory.vue for why
  // that doesn't apply to section15_material's own pass below.
  section15: {
    editEntities: ['section15', 'section15_material', 'section15_cas'],
  },
  section15_material: {
    editEntities: ['section15_material', 'section15_cas'],
  },
  section9: {
    editEntities: ['section9'],
  },
  section9_flash_point: {
    editEntities: ['section9_flash_point'],
  },
  section9_boiling_point: {
    editEntities: ['section9_boiling_point'],
  },
};

export const groupingDeleteEntities: string[] = [
  'section8_exposure_control',
  'section9_boiling_point',
  'section9_flash_point',
];

export const ignoreDeleteEntities: string[] = ['section2_label'];
